import { render, staticRenderFns } from "./ServiceOtherRow.vue?vue&type=template&id=11843168&scoped=true&"
import script from "./ServiceOtherRow.vue?vue&type=script&lang=js&"
export * from "./ServiceOtherRow.vue?vue&type=script&lang=js&"
import style0 from "./ServiceOtherRow.vue?vue&type=style&index=0&id=11843168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11843168",
  null
  
)

export default component.exports